import MuiListItem, { ListItemProps as MuiListItemProps } from '@material-ui/core/ListItem';

export type DSListItemProps = MuiListItemProps & { ['data-cy']?: string };

export const DSListItem = MuiListItem;
